import template from "./menu.html";
import "../menu.scss";

/**
 * @typedef  {Object} AppRoute
 * @property {String} title     the title of the AppRoute.
 * @property {String} route     the route of the AppRoute.
 * @property {String} target    the target of the AppRoute.
 * @property {Array}  items     the array of descendant AppRoutes.
 */

/**
 * @ngdoc controller
 * @name OdsMenu
 * @description
 * This component renders the menu.
 */
class OdsMenu {
  /**
   * Class constructor
   * @ignore
   */
  constructor() {
    /**
     * The filtered the {@link AppRoute} of the home.
     * @type {Object}
     */
    this.filteredHome = {};
    /**
     * The list of filtered main navigation {@link AppRoute}.
     * @type {Array}
     */
    this.filteredMainNav = [];
  }

  _setMenuItemActive(menuItem) {
      this.activeNav = menuItem.title;
      this.found = true;
      menuItem.active = true;
  }

  /**
   * Each time any of the navigation binding changes, update list of filtered navigations {@link AppRoute}.
   * Each time the current route changes, update the active navigation.
   *
   * @param {Object} changes               The binding changes.
   * @param {Object} changes.home          The home change object.
   * @param {Object} changes.mainNav       The mainNav change object.
   * @param {Object} changes.currentRoute  The currentRoute change object.
   */
  $onChanges({ home, mainNav, currentRoute }) {
    if (home && home.currentValue) {
      this.filteredHome = this.filterFn(this.home) ? this.home : {};
    }

    if (mainNav && mainNav.currentValue) {
      this.filteredMainNav = this._filterNavWithChildren(this.mainNav);
    }

    if (
      currentRoute &&
      currentRoute.currentValue &&
      angular.isArray(this.filteredMainNav)
    ) {
      this.found = false;
      this.filteredMainNav.forEach((nav) => {

        // MAIN level menu
        if (nav.route === this.currentRoute) {
          this._setMenuItemActive(nav);
        }

        // Iterate firstLevel items
        if (angular.isArray(nav.items)) {
          nav.items.forEach((item) => {
            if (item.route === this.currentRoute) {
              this._setMenuItemActive(item);
              nav.open = true;
            }

            // Iterate secondLevel items
            if (angular.isArray(item.items)) {
              item.items.forEach((secondItem) => {

                if (secondItem.route === this.currentRoute ) {
                  this._setMenuItemActive(secondItem);
                  nav.open = true;
                  item.open = true;
                }

                // Iterate thirdLevel items
                if (angular.isArray(secondItem.items)) {
                  secondItem.items.forEach((thirdItem) => {
                    if (thirdItem.route === this.currentRoute ) {
                      this._setMenuItemActive(thirdItem);
                      nav.open = true;
                      item.open = true;
                      secondItem.open = true;
                    }
                  });
                }
              });
            }
          });
        }
      });

      // If not found reset the active navigation.
      if (!this.found) {
        this.activeNav = "";
      }
    }
  }
  /**
   * Provides the list of nav items available; nav items should be visible
   * only when there's at least one available sub item or it has a route.
   *
   * @return {Array}
   */
  _filterNavWithChildren(navList) {
    // First filter the nav and items by the filterFn.
    return navList
      .filter((nav) => this.filterFn(nav))
      .map((nav) =>
        Object.assign({}, nav, {
          items: nav.items
            ? nav.items.filter((item) => this.filterFn(item))
            : [],
        })
      )
      .filter((nav) => nav.route || (nav.items && nav.items.length));
  }
  /**
   * Call the callback to check if we need to filter the {@link AppRoute} item.
   * If the response is undefined then just return true.
   *
   * @param {Object} item  the item to check.
   *
   * @return {Boolean}
   */
  filterFn(item) {
    const shouldShow = this.onFilter({ item });
    return angular.isDefined(shouldShow) ? shouldShow : true;
  }
}

/**
 * @ngdoc component
 * @name odsMenu
 * @description
 * The menu component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsMenu}
   */
  controller: OdsMenu,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String}   appName       the app name.
   * @property {String}   currentRoute  the current route.
   * @property {Array}    home          the {@link AppRoute} of the home.
   * @property {Array}    mainNav       the list of main navigation {@link AppRoute}.
   * @property {Boolean}  showError     if we have to display an error dot in the avatar.
   * @property {Function} onFilter      callback to filter the {@link AppRoute} items.
   */
  bindings: {
    appName: "@",
    currentRoute: "@",
    home: "<",
    mainNav: "<",
    showError: "<",
    onFilter: "&",
  },
};
